import { useSelector } from 'react-redux';

export const usePermission = (componentKey, denyOnly = false) => {
	const currentUser = useSelector((state) => state.user.currentUser);
	const isScopedUser = currentUser?.isScopedUser;
	let scopedPolicy = currentUser?.scopedPolicy || {};

	if (!isScopedUser) {
		return true;
	}

	if (typeof scopedPolicy === 'string') {
		try {
			scopedPolicy = JSON.parse(scopedPolicy);
		} catch (e) {
			scopedPolicy = {};
			console.error(e);
		}
	}

	const isAction = componentKey.startsWith('action');

	const isAllowed = isAction
		? scopedPolicy?.actions?.includes(componentKey)
		: (scopedPolicy?.ui?.includes(componentKey) ?? false);
	const isDenied = isAction
		? scopedPolicy?.actions?.includes(`!${componentKey}`)
		: (scopedPolicy?.ui?.includes(`!${componentKey}`) ?? false);

	return denyOnly ? !isDenied : !isDenied && isAllowed;
};
